import React, { useState } from "react";
import { motion } from "framer-motion";
import "bootstrap-icons/font/bootstrap-icons.css";

const preferencesList = [
  "Employees",
  "Clients",
  "Projects",
  "Contacts",
  "Companies",
  "Deals",
  "Leads",
  "Pipeline",
  "Activities",
  "Sales",
  "Accounting",
  "Reports",
];

export default function Preferences() {
  const [toggles, setToggles] = useState(
    preferencesList.reduce((acc, item) => {
      acc[item] = true;
      return acc;
    }, {})
  );

  const handleToggle = (item) => {
    setToggles((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  return (
    <motion.div
      className=" card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Preferences
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0 p-4"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        <div className="row">
          {preferencesList.map((item, i) => (
            <motion.div
              key={item}
              className="col-md-4 col-sm-6 mb-3"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.03 }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <span>{item}</span>

                {/* TOGGLE */}
                <motion.button
                  onClick={() => handleToggle(item)}
                  className="btn p-0 border-0"
                  style={{
                    width: 44,
                    height: 24,
                    borderRadius: 20,
                    background: toggles[item] ? "#198754" : "#dee2e6",
                    position: "relative",
                  }}
                  whileTap={{ scale: 0.9 }}
                  layout
                >
                  <motion.div
                    layout
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      background: "#fff",
                      position: "absolute",
                      top: 3,
                      left: toggles[item] ? 24 : 3,
                    }}
                  />
                </motion.button>
              </div>
            </motion.div>
          ))}
        </div>

        {/* ACTIONS */}
        <motion.div
          className="d-flex justify-content-end mt-4 gap-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-danger"
          >
            Cancel
          </motion.button>

          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-primary"
          >
            Save
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}